import { apiAxiosAuth } from 'services/api';
import { Product } from 'types/Product';

interface GetProductBySKUResp {
	isSuccess: boolean;
	products: Product[];
}

export async function getProductBySKU(
	productoToSeach: string,
	handleNotify: any
) {
	const resp: GetProductBySKUResp = { isSuccess: false, products: [] };

	const queryString = encodeURIComponent(
		`?query=${productoToSeach}&page=1&count=10&sort=release:desc&hideUnavailableItems=true`
	);

	await apiAxiosAuth
		.get(`intelligent-autocomplete-products/${queryString}`)
		.then((response) => {
			resp.products = response?.data?.products || [];
			resp.isSuccess = true;
		})
		.catch((error) => {
			handleNotify(error?.message || '', 'error');
			resp.products = [];
			resp.isSuccess = false;
		});

	return resp;
}
